import React, { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const empty = { current_password: "", new_password: "", confirm: "" };

// Self-service: the connected user changes their own password.
export function ChangeOwnPasswordDialog({ open, onOpenChange }) {
  const [f, setF] = useState(empty);
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const submit = async () => {
    if (f.new_password.length < 8) { toast.error("Le nouveau mot de passe doit contenir au moins 8 caractères"); return; }
    if (f.new_password !== f.confirm) { toast.error("La confirmation ne correspond pas au nouveau mot de passe"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Mot de passe modifié avec succès");
      setF(empty); onOpenChange(false);
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) setF(empty); onOpenChange(o); }}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>Changer mon mot de passe</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div><Label>Mot de passe actuel</Label><Input type="password" value={f.current_password} onChange={(e) => set("current_password", e.target.value)} className="mt-1" data-testid="cp-current" /></div>
          <div><Label>Nouveau mot de passe</Label><Input type="password" value={f.new_password} onChange={(e) => set("new_password", e.target.value)} className="mt-1" data-testid="cp-new" /></div>
          <div><Label>Confirmer le nouveau mot de passe</Label><Input type="password" value={f.confirm} onChange={(e) => set("confirm", e.target.value)} className="mt-1" data-testid="cp-confirm" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button className="bg-primary" onClick={submit} disabled={saving} data-testid="cp-submit">{saving ? "Enregistrement..." : "Enregistrer"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

// Super admin: reset any user's password.
export function AdminSetPasswordDialog({ open, onOpenChange, userId, userName }) {
  const [f, setF] = useState({ new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const submit = async () => {
    if (f.new_password.length < 8) { toast.error("Le mot de passe doit contenir au moins 8 caractères"); return; }
    if (f.new_password !== f.confirm) { toast.error("La confirmation ne correspond pas"); return; }
    setSaving(true);
    try {
      await api.post(`/users/${userId}/password`, { new_password: f.new_password });
      toast.success("Mot de passe réinitialisé");
      setF({ new_password: "", confirm: "" }); onOpenChange(false);
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) setF({ new_password: "", confirm: "" }); onOpenChange(o); }}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>Réinitialiser le mot de passe</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500 -mt-2">Définir un nouveau mot de passe pour <strong>{userName}</strong>.</p>
        <div className="space-y-4 mt-2">
          <div><Label>Nouveau mot de passe</Label><Input type="password" value={f.new_password} onChange={(e) => set("new_password", e.target.value)} className="mt-1" data-testid="asp-new" /></div>
          <div><Label>Confirmer le mot de passe</Label><Input type="password" value={f.confirm} onChange={(e) => set("confirm", e.target.value)} className="mt-1" data-testid="asp-confirm" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button className="bg-primary" onClick={submit} disabled={saving} data-testid="asp-submit">{saving ? "Enregistrement..." : "Réinitialiser"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
